export const THREE_COLUMNS = 'THREE_COLUMNS';
export const FOUR_COLUMNS = 'FOUR_COLUMNS';
export const SIX_COLUMNS = 'SIX_COLUMNS';
